var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"yellow-button",attrs:{"depressed":"","to":_vm.to,"disabled":_vm.disabled},on:{"click":function($event){return _vm.doClick($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }